import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::store
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:19
* @route '/api/v1/mini-app/avatar'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/api/v1/mini-app/avatar',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::store
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:19
* @route '/api/v1/mini-app/avatar'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::store
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:19
* @route '/api/v1/mini-app/avatar'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::store
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:19
* @route '/api/v1/mini-app/avatar'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::store
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:19
* @route '/api/v1/mini-app/avatar'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::destroy
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:27
* @route '/api/v1/mini-app/avatar'
*/
export const destroy = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/api/v1/mini-app/avatar',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::destroy
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:27
* @route '/api/v1/mini-app/avatar'
*/
destroy.url = (options?: RouteQueryOptions) => {
    return destroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::destroy
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:27
* @route '/api/v1/mini-app/avatar'
*/
destroy.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::destroy
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:27
* @route '/api/v1/mini-app/avatar'
*/
const destroyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\V1\MiniAppAvatarController::destroy
* @see app/Http/Controllers/Api/V1/MiniAppAvatarController.php:27
* @route '/api/v1/mini-app/avatar'
*/
destroyForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const avatar = {
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default avatar